<div id="app" [ngClass]="{'withmenu': authenticated && showNavigation}">
  <router-outlet></router-outlet>
  <app-alert></app-alert>
  <app-navigation *ngIf="authenticated"></app-navigation>
</div>
